<template>
<transition name="slide-fade">
    <div class="dialog-view invite_apply" v-if="dialogVisible" ref="modal">     
        <div class="u-window invite-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper dialog-content">
                <div class="dialog-body">
                    <div class="dialog-title t-invite"></div>

                    <div class="m-user">
                        <user-info/>
                    </div>

                    <div class="invite-view">
                        <div class="share-text msg-view">
                            <div class="text-content">
                                <p>3位好友助力成功后自动发放</p>
                            </div>
                        </div>

                        <div class="reward-view flex-center-center">
                            <div class="reward-item">
                                <div class="reward-pic" v-tips="'OL31'"><game-item :locked="true" :id="'OL31'" :num="200"></game-item></div>
                            </div>
                            <div class="reward-item">
                                <div class="reward-pic" v-tips="'KR48'"><game-item :locked="true" :id="'KR48'" :num="3"></game-item></div>
                            </div>
                            <div class="reward-item">
                                <div class="reward-pic" v-tips="'AN07'"><game-item :locked="true" :id="'AN07'" :num="1"></game-item></div>
                            </div>                            
                        </div>

                        <div class="invite-list">
                            <div class="list-item" v-for="(item,index) in friend_list" :key="'f-' + index">{{ item.nickName }}</div>
                            <div class="list-item default" v-for="n in (3 - friend_list.length)" :key="n">待邀请</div>
                        </div>

                        <div class="u-btn copy" @click="call_copy()"></div>
                    </div>

                </div>

            </div>         
        </div>
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
import {
    apiInviteList,   
} from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            error_text : '请稍后再试', 
            error : false,
            shareTxt : '',
            buff : false,
            friend_list : [], // 好友列表              
        }
    },
    created (){   
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.fetch_friends()
    }, 
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        fetch_friends(){
            apiInviteList().then(
                res => {
                    this.friend_list = res.data;
                }
            )
        },             
        call_copy(){
            this.destroyElement();
            this.$copy_modal({ shareTxt : this.shareTxt }); 
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              clipboard.destroy();
              _this.$toast("复制成功");
              _this.destroyElement();
            });
            clipboard.on('error', function () {
              clipboard.destroy()
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },             
    },
}
</script>

<style lang="scss" scoped>
.invite-modal{
    width: 656px;
    height: 717px;
    background-image: url(~@/assets/images/modal/bg-modal-lg.png);
}

.t-invite{
    width: 365px;
    height: 41px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/modal/title-invite.png);
}

.invite-view{
    padding: 0 20px 0;
}

.m-user{
    margin: 0 auto 20px;
}

.reward-view{
    margin-top: 20px;
    margin-bottom: 20px;

    .reward-item{
        width: 101px;
        height: 101px;
        margin: 0 17px;
        background-image: url(~@/assets/images/pc/bg-item.png);
        display: flex;
        align-items: center;
        justify-content: center;

        .reward-pic{
            width: 64px;
            height: 64px;
        }
    }
}

.text-content{
    font-size: 24px;
    color: #3b3f3e;
    line-height: 1.4;
    text-align: center;

    p{
        margin: 0;
    }
}

.invite-list{
    .list-item{
        width: 420px;
        height: 70px;
        line-height: 70px;
        margin: 0 auto 20px;
        text-align: center;
        border-radius: 10px;
        font-size: 20px;
        background-color: #e6e8dd;
        color: #3b3f3e;

        &.default{
            color: #a8adac;
        }
    }
}



.notice{
    margin-top: 20px;
    font-size: 18px;
    color: #ee6044;
    text-align: center;
}

.info{
    font-size: 20px;
    text-align: center;
    margin-bottom: 18px;
}

.u-btn.copy{
    width: 227px;
    height: 60px;
    margin: 15px auto 0;
    background-image: url(~@/assets/images/modal/btn-invite.png);
} 

</style>